import { request } from '../utils/request';

export const getUsers = () => request('/users');
export const createUser = (user) => request('/admin/create-user', 'POST', user);
export const updateUserRole = (id, role, objectIds) =>
  request(`/users/${id}/role`, 'PATCH', objectIds !== undefined ? { role, objectIds } : { role });
export const updateUserObjects = (id, objectIds) =>
  request(`/users/${id}/objects`, 'PUT', { objectIds });
export const getObjects = () => request('/objects');
export const deleteUser = (id) => request(`/users/${id}`, 'DELETE');

// Регионы
export const getRegions = () => request('/regions');
export const getUserRegions = (userId) => request(`/users/${userId}/regions`);
export const addUserRegionRole = (userId, regionId, role) => 
  request(`/users/${userId}/regions`, 'POST', { regionId, role });
export const updateUserRegionRole = (userId, regionRoleId, role) =>
  request(`/users/${userId}/regions/${regionRoleId}`, 'PATCH', { role });
export const removeUserRegionRole = (userId, regionRoleId) =>
  request(`/users/${userId}/regions/${regionRoleId}`, 'DELETE');
